@if (isMapApiLoaded()) {
  <google-map
    [height]="height()"
    width="100%"
    [center]="center"
    [zoom]="zoom"
    [options]="dynamicMapOptions"
    (mapClick)="onMapClick($event)"
  >
    <!-- Renderiza todos os marcadores -->
    @for (marker of markersToRender; track marker.id || $index) {
      <map-marker
        [position]="marker.position"
        [title]="marker.title || 'Marcador'"
        [options]="{ icon: customIcon }"
        (mapClick)="onMarkerClick(marker)"
      />
    }
  </google-map>
} @else {
  <div
    aria-hidden="true"
    [style.height]="height()"
    style="width: 100%; background: #f5f7fa; border-radius: 4px;"
  ></div>
}

<!-- @if (address()) {
  <p><strong>Endereço encontrado:</strong> {{ address() }}</p>
} -->
